import { gql } from "@apollo/client";

export const CREATE_EVENT = gql`
  mutation createEvent(
    $name: String!
    $eventTypeId: Int!
    $role: String
    $hashTag: String
  ) {
    createEvent(
      name: $name
      event_type_id: $eventTypeId
      role: $role
      hashTag: $hashTag
    ) {
      id
      uuid
      name
      created_at
      updated_at
      team {
        id
        user_uuid
        user {
          first_name
          last_name
        }
        event_id
        admin
        created_at
        updated_at
      }
      event_type {
        id
        name
        description
      }
      supported_currencies {
        currency
        providers
      }
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation updateEvent(
    $eventId: Int!
    $name: String
    $hashTag: String
    $welcomeMsg: String
    $wishlist_note: String
    $eventTimezone: String
    $defaultCurrencyIso: Currency
  ) {
    updateEvent(
      event_id: $eventId
      name: $name
      hashTag: $hashTag
      welcomeMsg: $welcomeMsg
      wishlist_note: $wishlist_note
      eventTimezone: $eventTimezone
      default_currency_iso: $defaultCurrencyIso
    ) {
      id
      name
      welcome_msg
      hash_tag
      wishlist_note
      eventTimezone
    }
  }
`;

export const UPDATE_EVENT_SLUG = gql`
  mutation updateEventSlug($eventId: Int!, $slug: String!) {
    updateEventSlug(event_id: $eventId, slug: $slug) {
      id
      name
      hash_tag
      slug
      welcome_msg
      created_at
      updated_at
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation deleteEvent($eventId: Int!) {
    deleteEvent(event_id: $eventId)
  }
`;

// Event Team Mutations

export const ADD_EVENT_TEAM_MEMBER = gql`
  mutation addEventTeamMember($team: TeamMemberInvite!) {
    addEventTeamMember(team: $team)
  }
`;

export const REMOVE_TEAM_MEMBER = gql`
  mutation removeTeamMember($eventId: UUID!, $teamMemberId: UUID!) {
    removeTeamMember(event_id: $eventId, team_member_id: $teamMemberId)
  }
`;

export const UPDATE_EVENT_TEAM_MEMBER_ROLE = gql`
  mutation UpdateEventTeamMemberRole(
    $teamMemberId: UUID!
    $eventId: UUID!
    $role: EventOwnerRole!
  ) {
    updateEventTeamMemberRole(
      team_member_id: $teamMemberId
      event_id: $eventId
      role: $role
    )
  }
`;

export const ACCEPT_EVENT_TEAM = gql`
  mutation acceptEventTeam($token: String!) {
    acceptEventTeam(token: $token) {
      event_id
      event_uuid
      event_name
      first_name
      last_name
      role
    }
  }
`;

// My Plan Mutations

export const ADD_CUSTOM_MY_PLAN_TASK = gql`
  mutation addCustomMyPlanTask(
    $eventId: UUID!
    $taskName: String!
    $description: String!
  ) {
    addCustomMyPlanTask(
      event_id: $eventId
      taskName: $taskName
      description: $description
    ) {
      id
      event_id
      eventUUID
      name
      description
      done
      due_date
      deadline
    }
  }
`;

export const DELETE_CUSTOM_MY_PLAN_TASK = gql`
  mutation deleteCustomMyPlanTask($eventId: UUID!, $taskId: UUID!) {
    deleteCustomMyPlanTask(event_id: $eventId, task_id: $taskId)
  }
`;

export const EDIT_CUSTOM_MY_PLAN_TASK = gql`
  mutation editCustomMyPlanTask(
    $eventId: UUID!
    $taskId: UUID!
    $taskName: String!
    $description: String!
  ) {
    editCustomMyPlanTask(
      event_id: $eventId
      task_id: $taskId
      taskName: $taskName
      description: $description
    ) {
      id
      event_id
      eventUUID
      name
      description
      done
      due_date
      deadline
    }
  }
`;

export const UPDATE_DONE_STATUS = gql`
  mutation updateDoneStatus(
    $eventId: UUID!
    $taskId: UUID!
    $isDone: Boolean!
  ) {
    updateDoneStatus(eventID: $eventId, task_id: $taskId, isDone: $isDone)
  }
`;

// Hero image Mutations

export const SET_HERO_IMAGE = gql`
  mutation setHeroImage($setHeroImageEventId2: Int!, $image: String!) {
    setHeroImage(event_id: $setHeroImageEventId2, image: $image)
  }
`;

export const REMOVE_HERO_IMAGE = gql`
  mutation removeHeroImage($eventId: Int!) {
    removeHeroImage(event_id: $eventId)
  }
`;

// Event Preference Mutations

export const UPDATE_EVENT_PREFERENCE = gql`
  mutation updateEventPreference($input: UpdateEventPreferenceRequest) {
    updateEventPreference(input: $input) {
      id
      event_id
      food
      ads
      asoebi_selection
      gifts
      store
      vendor_store
      reservation
      access_control
      dress_code
      map
      smart_send
      private
      live_hall
      guest_pov_default_public
      gift_in_invitation
      website_after_invitation
      faq
      recommendations
      plus_one_request
      force_guest_app_download
      created_at
      updated_at
    }
  }
`;

// Streamer and Live schedule Mutations

export const ADD_STREAMER_FROM_INVITE_LIST = gql`
  mutation addStreamerFromInviteList($args: [CreateStreamer!]!) {
    addStreamerFromInviteList(args: $args)
  }
`;

export const REMOVE_STREAMER_FROM_INVITE_LIST = gql`
  mutation removeStreamerFromInviteList($streamerId: String!) {
    removeStreamerFromInviteList(streamerId: $streamerId)
  }
`;

export const UPDATE_STREAMER = gql`
  mutation updateStreamer($args: UpdateStreamer!) {
    updateStreamer(args: $args)
  }
`;

export const CREATE_LIVE_SCHEDULE = gql`
  mutation createLiveSchedule(
    $eventUuid: String!
    $eventPartUuid: String!
    $link: String!
    $date: String!
    $time: String!
  ) {
    createLiveSchedule(
      eventUuid: $eventUuid
      eventPartUuid: $eventPartUuid
      link: $link
      date: $date
      time: $time
    )
  }
`;

export const UPDATE_LIVE_SCHEDULE = gql`
  mutation updateLiveSchedule(
    $updateLiveScheduleId: String!
    $link: String
    $date: String
    $time: String
  ) {
    updateLiveSchedule(
      id: $updateLiveScheduleId
      link: $link
      date: $date
      time: $time
    )
  }
`;

export const DELETE_LIVE_SCHEDULE = gql`
  mutation deleteLiveSchedule($deleteLiveScheduleId: String!) {
    deleteLiveSchedule(id: $deleteLiveScheduleId)
  }
`;

// Event Parts Mutations

export const ADD_EVENT_PART = gql`
  mutation addEventPart($input: AddEventPartRequest!) {
    addEventPart(input: $input) {
      id
      event_id
      time
      eventPartTimezone
      part
      name
      address
      geo_position {
        geo_position_id
        latitude
        longitude
      }
    }
  }
`;

export const EDIT_EVENT_PART = gql`
  mutation updateEventPart($input: UpdateEventPartRequest!) {
    updateEventPart(input: $input) {
      id
      event_id
      time
      eventPartTimezone
      part
      name
      address
      geo_position {
        geo_position_id
        latitude
        longitude
      }
    }
  }
`;

export const DELETE_EVENT_PART = gql`
  mutation deleteEventPart($eventId: Int!, $partId: Int!) {
    deleteEventPart(event_id: $eventId, partId: $partId)
  }
`;

// Event Vendor Mutations

export const ADD_EVENT_VENDOR = gql`
  mutation addEventVendor($input: AddEventVendorRequest!) {
    addEventVendor(input: $input) {
      id
      instagram_handle
      event_id
      role
      email
      name
      phone_number
      created_at
      updated_at
    }
  }
`;

export const UPDATE_EVENT_VENDOR = gql`
  mutation updateEventVendor($input: UpdateEventVendorRequest!) {
    updateEventVendor(input: $input) {
      id
      image
      instagram_handle
      name
      role
      event_id
      phone_number
    }
  }
`;

export const DELETE_EVENT_VENDOR = gql`
  mutation removeEventVendor($eventId: Int!, $vendorId: Int!) {
    removeEventVendor(event_id: $eventId, vendorId: $vendorId)
  }
`;

// Wishlist Mutations

export const ADD_WISHLIST_ITEM = gql`
  mutation addWishListItem(
    $eventId: UUID!
    $name: String!
    $image: String!
    $amount: Float!
    $currency: Currency!
    $link: String!
  ) {
    addWishListItem(
      event_id: $eventId
      name: $name
      image: $image
      amount: $amount
      currency: $currency
      link: $link
    ) {
      id
      name
      image
      amount
      currency
      link
    }
  }
`;

export const UPDATE_WISHLIST_ITEM = gql`
  mutation updateWishListItem(
    $eventId: UUID!
    $itemId: UUID!
    $name: String!
    $image: String!
    $amount: Float!
    $currency: Currency!
    $link: String!
  ) {
    updateWishListItem(
      event_id: $eventId
      itemId: $itemId
      name: $name
      image: $image
      amount: $amount
      currency: $currency
      link: $link
    ) {
      id
      name
      image
      amount
      currency
      link
    }
  }
`;

export const DELETE_WISHLIST_ITEM = gql`
  mutation deleteWishListItem($eventId: UUID!, $itemId: UUID!) {
    deleteWishListItem(event_id: $eventId, itemId: $itemId)
  }
`;

export const GENERATE_WISHLIST_PRESIGNED_URL = gql`
  mutation GenerateWishListPresignedUrl($event_id: UUID!, $mediaType: String!) {
    generateWishListPresignedUrl(event_id: $event_id, mediaType: $mediaType) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      event_id
    }
  }
`;

export const VERIFY_WISHLIST_UPLOAD = gql`
  mutation VerifyWishListUpload(
    $eventId: UUID!
    $fileUri: String!
    $itemId: UUID!
  ) {
    verifyWishListUpload(event_id: $eventId, fileUri: $fileUri, itemId: $itemId)
  }
`;

// Luxe Mutations

export const UPGRADE_TO_LUXE = gql`
  mutation UpgradeToLuxe($eventId: UUID!) {
    upgradeToLuxe(eventID: $eventId)
  }
`;

export const GENERATE_LUXE_PAYMENT_METADATA = gql`
  mutation generateLuxePaymentMetadata($input: LuxePaymentMetadataRequest!) {
    generateLuxePaymentMetadata(input: $input) {
      amount_after_discount
      amount_before_discount
      currency_iso
      custom_fields {
        display_name
        value
        variable_name
      }
      discount_amount_applied
      discount_percentage_applied
      event_id
      full_name
      hash
      inawo_product
      payment_provider
      payment_reference
      timestamp
      user_id
      total_payment_intent_amount
    }
  }
`;

export const SUBMIT_ABANDONED_PAYMENT_SURVEY = gql`
  mutation SubmitAbandonedPaymentSurvey(
    $eventId: UUID!
    $inawoProduct: String!
    $option: AbandonedPaymentReason!
    $text: String
    $email: Email
    $phone: E164
  ) {
    submitAbandonedPaymentSurvey(
      event_id: $eventId
      inawo_product: $inawoProduct
      option: $option
      text: $text
      email: $email
      phone: $phone
    )
  }
`;

// Chapters Mutations

export const ADD_WEDDING_PARTIES = gql`
  mutation addWeddingParty($eventId: UUID!, $input: addWeddingPartyReq!) {
    addWeddingParty(event_id: $eventId, input: $input) {
      first_name
      last_name
      nickname
      id
      event_id
      order_index
      role
      story
      image_url
    }
  }
`;

export const UPDATE_WEDDING_PARTIES = gql`
  mutation updateWeddingParty($eventId: UUID!, $input: updateWeddingPartyReq!) {
    updateWeddingParty(event_id: $eventId, input: $input) {
      first_name
      last_name
      nickname
      id
      event_id
      order_index
      role
      story
      image_url
    }
  }
`;

export const DELETE_WEDDING_PARTIES = gql`
  mutation deleteWeddingParty($eventId: UUID!, $id: UUID!) {
    deleteWeddingParty(event_id: $eventId, id: $id)
  }
`;

export const GENERATE_WEDDING_PARTY_PRESIGNED_URL = gql`
  mutation GenerateWeddingPartyPresignedUrl(
    $event_id: UUID!
    $mediaType: String!
  ) {
    generateWeddingPartyPresignedUrl(
      event_id: $event_id
      mediaType: $mediaType
    ) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      event_id
    }
  }
`;

// Back Stories Mutations

export const ADD_BACK_STORIES = gql`
  mutation addBackStory($eventId: Int!, $input: addBackStoryReq!) {
    addBackStory(event_id: $eventId, input: $input) {
      title
      id
      event_id
      role
      story
      image
    }
  }
`;

export const UPDATE_BACK_STORIES = gql`
  mutation updateBackStory($eventId: Int!, $input: updateBackStoryReq!) {
    updateBackStory(event_id: $eventId, input: $input) {
      title
      id
      event_id
      role
      story
    }
  }
`;

export const DELETE_BACK_STORIES = gql`
  mutation deleteBackStory($eventId: Int!, $id: Int!) {
    deleteBackStory(event_id: $eventId, id: $id)
  }
`;

export const GENERATE_BACKSTORY_PRESIGNED_URL = gql`
  mutation GenerateBackstoryPresignedUrl(
    $event_id: UUID!
    $mediaType: String!
  ) {
    generateBackstoryPresignedUrl(event_id: $event_id, mediaType: $mediaType) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      event_id
    }
  }
`;

// Inawo Pass Mutations

export const DOWNLOAD_INAWO_PASSES = gql`
  mutation DownloadInawoPasses($eventId: UUID!, $invitationIds: [UUID!]!) {
    downloadInawoPasses(event_id: $eventId, invitation_ids: $invitationIds)
  }
`;

export const SEND_INAWO_PASS = gql`
  mutation SendInawoPass($eventId: UUID!, $invitationIds: [UUID!]!) {
    sendInawoPass(event_id: $eventId, invitation_ids: $invitationIds)
  }
`;

export const AUTO_SEND_INAWO_PASS = gql`
  mutation AutoSendInawoPass($eventId: UUID!) {
    autoSendInawoPass(event_id: $eventId)
  }
`;

export const SET_PASS_IMAGE = gql`
  mutation SetPassImage($eventId: UUID!, $image: String!) {
    setPassImage(event_id: $eventId, image: $image)
  }
`;

// Media mutations

export const UPDATE_MEDIA_ORDER = gql`
  mutation UpdateMediaOrder(
    $event_id: UUID!
    $media_id: UUID!
    $order_index: Float!
  ) {
    updateMediaOrder(
      event_id: $event_id
      media_id: $media_id
      order_index: $order_index
    ) {
      id
      name
      url
      tags
      type
      meta {
        s3_url
        height
        width
      }
      order_index
      created_at
      updated_at
    }
  }
`;

export const CREATE_ALBUM = gql`
  mutation createAlbum($eventId: UUID!, $name: String!, $description: String) {
    createAlbum(event_id: $eventId, name: $name, description: $description) {
      id
      name
      description
    }
  }
`;

export const UPDATE_ALBUM = gql`
  mutation updateAlbum(
    $eventId: UUID!
    $albumId: UUID!
    $name: String!
    $description: String
  ) {
    updateAlbum(
      event_id: $eventId
      album_id: $albumId
      name: $name
      description: $description
    ) {
      id
      name
      description
    }
  }
`;

export const ADD_MEDIA = gql`
  mutation addMedia($eventId: UUID!, $url: String!, $tags: [AlbumMediaTag!]!) {
    addMedia(event_id: $eventId, url: $url, tags: $tags) {
      id
      name
      url
      tags
      type
      meta {
        s3_url
        height
        width
      }
      order_index
      created_at
      updated_at
    }
  }
`;

export const ADD_MEDIA_TO_ALBUM = gql`
  mutation AddMediaToAlbum(
    $eventId: UUID!
    $albumId: UUID!
    $mediaIds: [String!]!
    $tags: [AlbumMediaTag!]
  ) {
    addMediaToAlbum(
      event_id: $eventId
      album_id: $albumId
      media_ids: $mediaIds
      tags: $tags
    )
  }
`;

export const BULK_DELETE_MEDIA = gql`
  mutation BulkDeleteMedia($eventId: UUID!, $mediaId: [UUID!]!) {
    bulkDeleteMedia(event_id: $eventId, media_id: $mediaId)
  }
`;

export const DELETE_MEDIA = gql`
  mutation deleteMedia($eventId: UUID!, $mediaId: UUID!) {
    deleteMedia(event_id: $eventId, media_id: $mediaId)
  }
`;
export const DELETE_ALBUM = gql`
  mutation deleteAlbum($eventId: UUID!, $albumId: UUID!) {
    deleteAlbum(event_id: $eventId, album_id: $albumId)
  }
`;

export const GET_MEDIA_PRESIGNED_URL = gql`
  mutation GetMediaPresignedUrl($event_id: UUID!, $mediaType: String!) {
    getMediaPresignedUrl(event_id: $event_id, mediaType: $mediaType) {
      upload_url
      file_uri
      thumbnail_uri
      expiry_time
      expiry_time_in_seconds
      event_id
      media_id
    }
  }
`;

export const VERIFY_MEDIA_UPLOAD = gql`
  mutation VerifyMediaUpload(
    $event_id: UUID!
    $url: String!
    $tags: [AlbumMediaTag!]!
  ) {
    verifyMediaUpload(event_id: $event_id, url: $url, tags: $tags)
  }
`;

// Website Mutations

export const SELECT_WEBSITE_TEMPLATE = gql`
  mutation SelectTemplate($req: SelectTemplateReq!) {
    selectTemplate(req: $req)
  }
`;

export const CREATE_MESSAGE = gql`
  mutation createMessage($eventId: Int!, $content: String!) {
    createMessage(event_id: $eventId, content: $content)
  }
`;

export const REPLY_MESSAGE = gql`
  mutation replyMessage($eventId: Int!, $messageId: Int!, $reply: String!) {
    replyMessage(event_id: $eventId, message_id: $messageId, reply: $reply)
  }
`;

export const DELETE_MESSAGE_BY_ID = gql`
  mutation deleteMessageById($eventId: Int!, $messageId: Int!) {
    deleteMessageById(event_id: $eventId, message_id: $messageId)
  }
`;

export const SET_EVENT_CACHE = gql`
  mutation SetEventCache(
    $eventId: UUID!
    $key: String!
    $value: Map!
    $expiryInSeconds: Int!
  ) {
    setEventCache(
      event_id: $eventId
      key: $key
      value: $value
      expiry_in_seconds: $expiryInSeconds
    )
  }
`;

export const CLEAR_EVENT_CACHE = gql`
  mutation ClearEventCache($eventId: UUID!, $key: String!) {
    clearEventCache(event_id: $eventId, key: $key)
  }
`;

export const GENERATE_CUSTOM_DOMAIN_PAYMENT_METADATA = gql`
  mutation GenerateCustomDomainPaymentMetadata(
    $input: CustomDomainPaymentMetadataRequest!
  ) {
    generateCustomDomainPaymentMetadata(input: $input) {
      inawo_product
      custom_domain_payment_id
      event_id
      user_id
      payment_reference
      payment_provider
      currency_iso
      domain_name
      tld
      years
      auto_renew
      registrar
      registrar_fee
      cloudflare_fee
      vercel_fee
      fee
      vat
      total_amount
      hash
      timestamp
      contact_info {
        first_name
        last_name
        email
        phone_number
        address_line1
        address_line2
        city
        state
        country
        postal_code
      }
      custom_fields {
        display_name
        variable_name
        value
      }
      total_payment_intent_amount
    }
  }
`;

export const ATTACH_DOMAIN = gql`
  mutation AttachDomain($input: AttachDomainInput!) {
    attachDomain(input: $input) {
      id
      user_id
      event_id
      domain_name
      status
      purchase_date
      expiry_date
      renewal_price
      purchase_price
      currency
      auto_renew
      dns_configured
      created_at
      updated_at
      user {
        uuid
        id
        email
        first_name
        last_name
      }
      event {
        id
        name
        luxe
        slug
        uuid
      }
    }
  }
`;

export const DETACH_DOMAIN = gql`
  mutation DetachDomain($input: DetachDomainInput!) {
    detachDomain(input: $input) {
      id
      user_id
      event_id
      domain_name
      status
      purchase_date
      expiry_date
      renewal_price
      purchase_price
      currency
      auto_renew
      dns_configured
      created_at
      updated_at
      user {
        uuid
        id
        email
        first_name
        last_name
      }
      event {
        id
        uuid
        name
        slug
        luxe
      }
    }
  }
`;

// Recommendations List Mutations

export const CREATE_REC_LIST = gql`
  mutation CreateRecList($input: CreateRecListInput!) {
    createRecList(input: $input) {
      id
      name
      category
      description
      items {
        id
        name
        description
        contactInfo
        link
        mediaUrl
        mediaType
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_REC_LIST = gql`
  mutation UpdateRecList(
    $updateRecListId: UUID!
    $name: String
    $category: RecCategory
    $description: String
  ) {
    updateRecList(
      id: $updateRecListId
      name: $name
      category: $category
      description: $description
    ) {
      id
      name
      category
      description
      items {
        id
        name
        description
        contactInfo
        link
        mediaUrl
        mediaType
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_REC_LIST = gql`
  mutation DeleteRecList($deleteRecListId: UUID!) {
    deleteRecList(id: $deleteRecListId)
  }
`;

export const CREATE_REC_ITEM = gql`
  mutation CreateRecItem($input: CreateRecItemInput!) {
    createRecItem(input: $input) {
      id
      name
      description
      contactInfo
      link
      mediaUrl
      mediaType
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_REC_ITEM = gql`
  mutation UpdateRecItem(
    $updateRecItemId: UUID!
    $name: String
    $description: String
    $contactInfo: String
    $link: String
    $mediaUrl: String
    $mediaType: RecMediaType
  ) {
    updateRecItem(
      id: $updateRecItemId
      name: $name
      description: $description
      contactInfo: $contactInfo
      link: $link
      mediaUrl: $mediaUrl
      mediaType: $mediaType
    ) {
      id
      name
      description
      contactInfo
      link
      mediaUrl
      mediaType
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_REC_ITEM = gql`
  mutation DeleteRecItem($deleteRecItemId: UUID!) {
    deleteRecItem(id: $deleteRecItemId)
  }
`;

// Chat Guest Website Mutations

export const CHAT_GUEST_WEBSITE = gql`
  mutation ChatGuestWebsite(
    $eventId: UUID!
    $message: String!
    $startFresh: Boolean!
  ) {
    chatGuestWebsite(
      event_id: $eventId
      message: $message
      start_fresh: $startFresh
    ) {
      status
      preview_url
      summary
      error
      turns_left
      history {
        role
        content
      }
    }
  }
`;

export const PUBLISH_GUEST_WEBSITE = gql`
  mutation PublishGuestWebsite($event_id: UUID!) {
    publishGuestWebsite(event_id: $event_id)
  }
`;

export const UNPUBLISH_GUEST_WEBSITE = gql`
  mutation UnpublishGuestWebsite($event_id: UUID!) {
    unpublishGuestWebsite(event_id: $event_id)
  }
`;

export const UPLOAD_GUEST_WEBSITE_HTML = gql`
  mutation UploadGuestWebsiteHTML($event_id: UUID!, $html: String!) {
    uploadGuestWebsiteHTML(event_id: $event_id, html: $html) {
      preview_url
    }
  }
`;

// Couple Image Mutations

export const GENERATE_COUPLE_IMAGE_PRESIGNED_URL = gql`
  mutation GenerateCoupleImagePresignedUrl(
    $event_id: UUID!
    $mediaType: String!
    $role: CoupleRole!
  ) {
    generateCoupleImagePresignedUrl(
      event_id: $event_id
      mediaType: $mediaType
      role: $role
    ) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      event_id
    }
  }
`;

// export const GENERATE_GROOM_IMAGE_PRESIGNED_URL = gql`
//   mutation GenerateGroomImagePresignedUrl(
//     $event_id: UUID!
//     $mediaType: String!
//   ) {
//     generateGroomImagePresignedUrl(event_id: $event_id, mediaType: $mediaType) {
//       upload_url
//       file_uri
//       expiry_time
//       expiry_time_in_seconds
//       event_id
//     }
//   }
// `;

export const VERIFY_COUPLE_IMAGE_UPLOAD = gql`
  mutation VerifyCoupleImageUpload(
    $eventId: UUID!
    $fileUri: String!
    $role: CoupleRole!
  ) {
    verifyCoupleImageUpload(event_id: $eventId, fileUri: $fileUri, role: $role)
  }
`;

// export const VERIFY_BRIDE_IMAGE_UPLOAD = gql`
//   mutation VerifyBrideImageUpload($eventId: UUID!, $fileUri: String!) {
//     verifyBrideImageUpload(event_id: $eventId, fileUri: $fileUri)
//   }
// `;
